export default __webpack_public_path__ + "static/tragos-da1ed778a896f3a810bd8a962dba94e0.jpg";